<template>
  <div>
    <header class="row align-center">
      <div class="columns small-12 medium-10 large-6">
        <h1>{{ title }}</h1>
        <p>{{ description }}</p>
      </div>
    </header>
    <section class="row align-center">
      <div class="columns small-12">
        <iframe
          id="suggest-resource"
          :src="formLink()"
          width="100%"
          height="1700"
          title="Suggest a Resource form"
        >
          Loading…
        </iframe>
      </div>
    </section>
  </div>
</template>

<script>
/* Suggest a Resource
 *
 * @parent:
 * @requests:
 * @events:
 * @props:
 * @components:
 * @methods:
 */

import { mapGetters } from 'vuex';

const newUsForm = (email, _) =>
  `https://docs.google.com/forms/d/e/1FAIpQLSdS7q8EFxu0DX7w2Ek7kEjJ7tK34Kol0ttg5JcP7FwRzHHevA/viewform?usp=pp_url&entry.1197822237=${email}`;
const newAuForm = (email, _) =>
  `https://docs.google.com/forms/d/e/1FAIpQLSewlu_cYsWDsuCBa97VgReWPC5N-RoXRY38j4eUDfwRRlEuNQ/viewform?usp=pp_url&entry.1197822237=${email}`;
const oldForm = (email, locale) =>
  'https://docs.google.com/forms/d/e/1FAIpQLSf5P3fSk4D6GkoNg9Zu96D9oaMRHs6WR8KAJ-8a4XsEujk87w/viewform?embedded=true&usp=pp_url&entry.1996386448=' +
  email +
  '&entry.1993147957=' +
  locale.toUpperCase();

const links = {
  us: newUsForm,
  au: newAuForm,
  gb: oldForm,
};

export default {
  name: 'SuggestAResourceForm',
  data() {
    return {
      title: 'Share Your Resource Idea',
      description:
        'Suggestions and feedback from the members of the Teach Starter community help us spark more “aha” moments for teachers and students.',
      email: '',
    };
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
      ],
      link: this.$hrefLangsPage(this.$route),
    };
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'loggedInUser', 'location']),
  },
  mounted() {
    if (this.isAuthenticated) {
      this.email = this.loggedInUser.email;
    }
    this.$mzAnalyticsApi({
      event: 'pageView',
    });
  },
  methods: {
    formLink() {
      return links[this.$i18n?.locale || 'au'](this.email, this.$i18n.locale);
    },
  },
};
</script>

<style scoped lang="scss">
header {
  img {
    border-radius: $base-border-radius;
    margin: $base-padding * 2 0;
  }
}
#suggest-resource {
  height: 106rem;
}
</style>
